import { Badge, Box, Tooltip } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { Order } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { can } from "@src/utils/components/permissions";
import { map } from "lodash";
import { observer } from "mobx-react-lite";

interface PurchaseOrderBadgeProps {
  orders: Pick<Order, "id" | "purchase_order_no">[];
  onCreate: () => void;
}

const PurchaseOrderBadge = ({ orders, onCreate }: PurchaseOrderBadgeProps) => {
  const canCreateOrder = can("order_create");

  const _onCreate = () => canCreateOrder && onCreate();

  return (
    <Tooltip
      isDisabled={!(orders.length > 1 || orders.length === 0)}
      label={
        <div className="p-2 text-lg">
          {map(orders.slice(1), (o) => (
            <p
              key={`${o.id}-${o.purchase_order_no}`}
            >{t`PO: ${o.purchase_order_no}`}</p>
          ))}
          {orders.length === 0 && t`Add new order`}
        </div>
      }
    >
      <button
        type="button"
        onClick={orders.length === 0 ? _onCreate : undefined}
        disabled={orders.length !== 0 || !canCreateOrder}
      >
        <Badge
          pos="relative"
          alignItems="center"
          display="flex"
          cursor={orders.length === 0 && canCreateOrder ? "pointer" : undefined}
          colorScheme="yellow"
        >
          <p className="truncate" style={{ maxWidth: "15rem" }}>
            {orders.length === 0
              ? t`No purchase orders`
              : t`PO: ${orders[0].purchase_order_no}`}
          </p>
          {(orders.length === 0 && canCreateOrder && (
            <Box pos="absolute" top="-2" right="-2">
              <Icon name="plus-circle" variant="solid" color="black" />
            </Box>
          )) ||
            (orders.length > 1 && (
              <Badge ml="2" px="2" colorScheme="grey">
                {`+${orders.length - 1}`}
              </Badge>
            ))}
        </Badge>
      </button>
    </Tooltip>
  );
};

export default observer(PurchaseOrderBadge);
